<template>
  <div class="card px-2 py-2">
    <h4>{{ $t("navigations.soas") }}</h4>

    <div class="text-center" v-if="loading">
      <img src="../../assets/img/loading.gif" width="15" />
      <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
    </div>

    <div v-else id="scrollBody">
      <div v-if="armList.length === 0" class="text-center">
        {{ $t("navigations.no data available") }}
      </div>
      <div v-else class= "scrollable">
        <ul class="tree pl-1 ">

          <!-- ARM LEVEL -->
          <li v-for="arm in armList" :key="arm.ArmCode">
                 <div class="arm-action pt-1">
                <button :popovertarget="`arm-popup-` + arm.ArmCode" :anchor="`arm-popup-` + arm.ArmCode"
                 
                  class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                  <i class="fa fa-ellipsis-v"></i>
                </button>

                <div :id="`arm-popup-` + arm.ArmCode" popover class="tmf-docs-popup-menu">
                  <button class="popup-menu-block text-start" @click.prevent="handleCreateVisit(arm.ArmCode)">
                    Create Visit
                  </button>
                </div>
              </div>

            <input type="checkbox" :id="arm.ArmCode" :checked="openArms.includes(arm.ArmCode)"
              @change="toggleArm(arm.ArmCode)" />

            <label class="tree_label" :for="arm.ArmCode">
              {{ arm.ArmCode }} : {{ arm.ArmName }}
            </label>

          <ul v-if="openArms.includes(arm.ArmCode)">

            <!-- ===== PHASES ===== -->
              <template v-if="phaseList[arm.ArmCode] && phaseList[arm.ArmCode].length">

                <li v-for="phase in phaseList[arm.ArmCode]" :key="phase.phaseId">

                  <!-- PHASE CHECKBOX -->
                  <input type="checkbox" :id="phase.phaseId" :checked="openPhases.includes(phase.phaseId)"
                    @change="togglePhase(phase.phaseId)" />

                  <label class="tree_label" :for="phase.phaseId">
                    {{ phase.phaseName }}
                  </label>

                  <!-- ===== VISITS UNDER PHASE ===== -->
                  <ul v-if="openPhases.includes(phase.phaseId)">
                    <li v-for="visit in visitList[arm.ArmCode][phase.phaseId]" :key="visit.visitId">

                      <div class="d-flex justify-content-between align-items-center">

                        <div class="w-100">
                          <input type="checkbox" :id="visit.visitId" :checked="openVisits.includes(visit.visitId)"
                            @change="toggleVisit(arm.ArmCode, visit.visitId)" />

                          <label class="tree_label" :for="visit.visitId">
                            {{ visit.visitNo }} : {{ visit.visitFormName }}
                          </label>
                        </div>

                        <!-- VISIT MENU -->
                        <div class="position-relative">
                          <button :popovertarget="'visit-popup-' + visit.visitId"
                            class="tmf-doc-ellipsis-btn border-0 bg-transparent px-2 pt-2">
                            <i class="fa fa-ellipsis-v"></i>
                          </button>

                          <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>

                            <button class="popup-menu-block" @click.prevent="editVisit(visit.visitId, arm.ArmCode)">
                              {{ $t('navigations.edit') }}
                            </button>

                            <button class="popup-menu-block" @click.prevent="deleteVisit(visit.visitId)">
                              {{ $t('navigations.delete') }}
                            </button>

                            <button class="popup-menu-block" @click.prevent="openVisitActivityModal(visit.visitId)">
                              {{ $t('navigations.assign activity') }}
                            </button>

                          </div>
                        </div>

                      </div>

                      <!-- ===== ACTIVITIES ===== -->
                      <ul v-if="openVisits.includes(visit.visitId)">
                        <li v-for="activity in activityList[visit.visitId]" :key="activity.activityId">

                          <input type="checkbox" :id="visit.visitId + '-' + activity.activityId"
                            :checked="openActivities.includes(visit.visitId + '-' + activity.activityId)"
                            @change="toggleActivity(visit.visitId, activity.activityId)" />

                          <label class="tree_label" :for="visit.visitId + '-' + activity.activityId">
                            {{ activity.activityOrder }} : {{ activity.activityName }}
                          </label>

                          <!-- ===== FORMS ===== -->
                          <ul v-if="openActivities.includes(visit.visitId + '-' + activity.activityId)">
                            <li v-for="form in formList[visit.visitId + '-' + activity.activityId]"
                              :key="form.templateId">

                              <div class="form-item" @click="viewForms(form.templateId)">
                                <input type="checkbox" :id="form.templateId" @click.stop />

                                <label :for="form.templateId" class="tree_form">
                                  {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                                </label>
                              </div>

                            </li>
                          </ul>

                        </li>
                      </ul>

                    </li>
                  </ul>

                </li>
              </template>

              <!-- ===== NO PHASE VISITS (DIRECT UNDER ARM) ===== -->
              <template v-if="visitList[arm.ArmCode] && visitList[arm.ArmCode].noPhase?.length">

                <li v-for="visit in visitList[arm.ArmCode].noPhase" :key="visit.visitId">

                  <div class="d-flex justify-content-between align-items-center">

                    <div>
                      <input type="checkbox" :id="visit.visitId" :checked="openVisits.includes(visit.visitId)"
                        @change="toggleVisit(arm.ArmCode, visit.visitId)" />

                      <label class="tree_label" :for="visit.visitId">
                        {{ visit.visitNo }} : {{ visit.visitFormName }}
                      </label>
                    </div>

                    <!-- VISIT MENU -->
                    <div class="position-relative">
                      <button :popovertarget="'visit-popup-' + visit.visitId"
                        class="tmf-doc-ellipsis-btn border-0 bg-transparent px-2 pt-2">
                        <i class="fa fa-ellipsis-v"></i>
                      </button>

                      <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu" @click.stop>

                        <button class="popup-menu-block" @click.prevent="editVisit(visit.visitId, arm.ArmCode)">
                          {{ $t('navigations.edit') }}
                        </button>

                        <button class="popup-menu-block" @click.prevent="deleteVisit(visit.visitId)">
                          {{ $t('navigations.delete') }}
                        </button>

                        <button class="popup-menu-block" @click.prevent="openVisitActivityModal(visit.visitId)">
                          {{ $t('navigations.assign activity') }}
                        </button>

                      </div>
                    </div>

                  </div>

                  <!-- ACTIVITIES -->
                  <ul v-if="openVisits.includes(visit.visitId)">
                    <li v-for="activity in activityList[visit.visitId]" :key="activity.activityId">

                      <input type="checkbox" :id="visit.visitId + '-' + activity.activityId"
                        :checked="openActivities.includes(visit.visitId + '-' + activity.activityId)"
                        @change="toggleActivity(visit.visitId, activity.activityId)" />

                      <label class="tree_label" :for="visit.visitId + '-' + activity.activityId">
                        {{ activity.activityOrder }} : {{ activity.activityName }}
                      </label>

                      <ul v-if="openActivities.includes(visit.visitId + '-' + activity.activityId)">
                        <li v-for="form in formList[visit.visitId + '-' + activity.activityId]" :key="form.templateId">

                          <div class="form-item" @click="viewForms(form.templateId)">
                            <input type="checkbox" :id="form.templateId" @click.stop />
                            <label :for="form.templateId" class="tree_form">
                              {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                            </label>
                          </div>

                        </li>
                      </ul>

                    </li>
                  </ul>

                </li>
              </template>


        

            </ul>

          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- FORM MODAL -->
  <showformmodel v-if="setshowActivityFormModal" :formid="formActivityId" currentformstatus="not completed"
    @closeformModal="closeformActivityModal()" />

  <VisitActivityModal v-if="showActivityModal" :visitId="visitId" :version="selectedVersion"
    @closeModal="closeActivitModal()"/>

  <!-- <manageVisitModal v-if="showSiteModal" :visitId="visitId" :version="selectedVersion" @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal" /> -->
 <manageVisitModal 
  v-if="showSiteModal" 
  :visitId="visitId" 
  :armCode="currentArmCode" 
  @visitUpdated="refreshVisitList" 
  @closeModal="closeModal()"
  @visitSaved="openVisitActivityModal" 
/>
</template>
<script src="./SoaTree.js"></script>
<style scoped>
.tmf-docs-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.tmf-docs-popup-menu {
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}
.card h4 {
  font-size: 13px !important;
  font-weight: 600;
}

.tmf-docs-popup-menu>button {
  width: 100%;
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.popup-menu-block:hover {
  background-color: #e4eaf9;
}
</style>